import ApiService from "@/services/api.service";

class FetchingError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const OrdersService = {
    resetPassword: async function (payload) {
        try {
            const response = await ApiService.post(
                'user_reset_pw',
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchInvoiceAddress: async function (payload) {
        try {
            const response = await ApiService.post(
                'fetch_address',
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    signIn: async function (payload) {
        try {
            const response = await ApiService.post(
                'user_sign_in',
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    userExists: async function (payload) {
        try {
            const response = await ApiService.post(
                'check_if_user_exists',
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    getOrCreateClient: async function (payload) {
        try {
            const response = await ApiService.post(
                'get_or_create_client',
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchCategories: async function () {
        try {
            const response = await ApiService.post(
                'fetch_categories'
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchCategory: async function (payload) {

        try {
            const response = await ApiService.post(
                'fetch_category_and_prices', 
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    checkVerifyCode: async function (payload) {

        try {
            const response = await ApiService.post(
                'check_verify_code', payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    resetCode: async function (payload) {

        try {
            const response = await ApiService.post(
                'reset_verify_code', payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchClient: async function (payload) {
        try {
            const response = await ApiService.post(
                'fetch_client', 
                payload
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    determineLocation: async function( payload ) {
        try {
            const { zipCity } = payload
            const is_zip = zipCity.match(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/);
            return {
                zip: is_zip ? zipCity : '',
                city: !is_zip ? zipCity : '',
                zipCity: zipCity
            }
            // const response = await ApiService.post(
            //     'determine_location',
            //     payload
            // )
            // return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchCountries: async function() {
        try {
            const response = await ApiService.post(
                'fetch_countries'
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    fetchFlexibleDateHints: async function () {
        try {
            const response = await ApiService.post(
                'fetch_flexible_date_hints'
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    
    fetchLaborForces: async function (data) {
        try {
            const response = await ApiService.post(
                'fetch_labor_forces',
                data
            )
            return response.data.result;
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },

    generatePdf: async function (data) {
        try {
            const base = process.env.NODE_ENV == "test" ? "https://dev.portal.offenblende.de/api" : "https://dev.portal.offenblende.de/api";
            const url = `${base}?view=jobs_calc_offer&hash=${data.jobs_hash}`;
            // const response = await ApiService.get(url, {
            //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            //     responseType: 'blob',
            // });
            const response = await ApiService.post('jobs_calc_offer', {
                hash: data.jobs_hash
            });
            return response.data;
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
    
    saveOrder: async function (payload) {
        const request_data = payload;
        try {
            const response = await ApiService.post(
                'create_job_beta',
                request_data
            )
            return response.data
        } catch (error) {
            const message = error.response.data.message || error.response.data;
            throw new FetchingError(error.response.status, message)
        }
    },
}

export default OrdersService

export { OrdersService, FetchingError }